import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {Box} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Divider } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { getUserPreference } from '../../../utilities/common';
import { createPickupManifest, getPickupOrder } from '../../../actions/driverPickupActions';
import FullscreenLoading from '../../Common/FullscreenLoading';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import PickupSearch from '../PickupSearch';
import PickupList from '../PickupList';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  section: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  boxStyle: {
    height: 750
  }
}));

export default function CreatePickupList(props) {
  const classes = useStyles();
  const {t} = useTranslation('driverPickup');
  const dispatch = useDispatch();
  const userPref = getUserPreference();

  const columns = [
    {field: 'id', flex:1, headerName: t('order_id'), width: 140, headerAlign: 'center', align: 'center'},
    {
      field: 'tno', flex:1, headerName: 'TNO', width: 200, headerAlign: 'center', align: 'center'
    },
    {
      field: 'add_time', 
      headerName: t('add_time'), 
      headerAlign: 'center', 
      width: 200,
      flex:1, 
      valueFormatter: (params)=>params.value?moment.unix(params.value).format("MMM DD, YYYY - HH:mm:ss"):'',
      align: 'center'
    },
    {field: 'sub_batch_no', flex:1, headerName: t('sub_batch_no'), width: 150, sortable: false, headerAlign: 'center', align: 'center'}
  ];

  const [isDataLoading, setIsDataLoading] = useState(false);
  const [partnerId, setPartnerId] = useState();
  const [manifestNo, setManifestNo] = useState('');
  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [fromDate, setFromDate] = useState(moment());
  const [toDate, setToDate] = useState(moment());
  const [pickupWarehouse, setPickupWarehouse] = useState(`-1`);

  const _handleSearch = (from_date, to_date, partner_id, pickup_warehouse) => {
    setIsDataLoading(true);
    setFromDate(from_date);
    setToDate(to_date);
    setPartnerId(partner_id);
    setPickupWarehouse(pickup_warehouse);
    let params = {
      fromTS: moment(from_date).startOf('day').valueOf() / 1000,
      toTS: Math.floor(moment(to_date).endOf('day').valueOf() / 1000),
      partner_id: partner_id
    }
    if(pickup_warehouse && pickup_warehouse !== `-1`) {
      params['pickup_warehouse'] = pickup_warehouse
    }
    dispatch(getPickupOrder(params))
    .then((res) => {
        setOrderList(res);
        if(res.length === 0) {
          dispatch(showAlertSnackbar({message: t('no_res'), type: 'warning'}))
        }
    })
    .catch(() => {
      dispatch(showAlertSnackbar({message: t('fetch_failure'), type: 'error'}))
    })
    .finally(() => {
      setIsDataLoading(false);
    })
  }

  function handleCreateManifest(selected) {
    setIsCreateLoading(true);
    let params = {
      order_ids: selected,
      creator: userPref.username,
      partner_id: partnerId
    }
    if(manifestNo) {
      params['manifest_no'] = manifestNo;
    }
    dispatch(createPickupManifest(params))
    .then((res) => {
      _handleSearch(fromDate, toDate, partnerId, pickupWarehouse);
      dispatch(showAlertSnackbar({message: res, type: 'info'}))
    })
    .catch(() => {
      dispatch(showAlertSnackbar({message: t('create_failure'), type: 'error'}))
    })
    .finally(()=>{
      setIsCreateLoading(false);
    })
  }
  function createRows(){
    return orderList.map((row) => {
        const {order_id, id, ...rest} = row
        return {id: order_id, temp: id, ...rest}
    })
  }

  useEffect(() => {
    if(props.open) {
      setOrderList([]);
    }
  }, [props.open])

  return (
    <Box style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
        <div className={classes.section}>
        <PickupSearch 
            onSearchClick={_handleSearch}
            type={'create'}
        />
        </div>
        <Divider />
        <div className={classes.section} style={{flexGrow: 1}}>
          <PickupList
            isDataLoading={isDataLoading}
            createRows={createRows||[]}
            columns={columns}
            list={orderList}
            setValue={setManifestNo}
            handleSubmit={handleCreateManifest}
            type={'create'}
            title={t('create_list')}
            dialogTitle={t('submit_title')}
            dialogMessage={t('save_exist_manifest_message')}
            dialogPlaceholder={t('input_exist')}
            pickupWarehouse={pickupWarehouse}
          />
        </div>
        <FullscreenLoading open={isCreateLoading}/>
    </Box>
  );
}